import React, { useState, useEffect } from 'react';
import { Button, Grid, Autocomplete, TextField, Select, MenuItem, FormControl, Table, InputLabel, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer, TablePagination, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionAnalisisPerfil() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [perfiles, setPerfiles] = useState([]);
    const [analisisDisponibles, setAnalisisDisponibles] = useState([]);
    const [analisisAsignados, setAnalisisAsignados] = useState([]);
    const [perfilSeleccionado, setPerfilSeleccionado] = useState(null);
    const [tipoPrecio, setTipoPrecio] = useState('');
    const [tiposPrecio, setTiposPrecio] = useState([]);
    const [perfil, setPerfil] = useState('');
    // Estados para la paginación de las tablas
    const [pageDisponibles, setPageDisponibles] = useState(0);
    const [rowsPerPageDisponibles, setRowsPerPageDisponibles] = useState(5);

    const [pageAsignados, setPageAsignados] = useState(0);
    const [rowsPerPageAsignados, setRowsPerPageAsignados] = useState(5);

    const [openModal, setOpenModal] = useState(false); // Estado para manejar la apertura del modal

    const [searchQuery, setSearchQuery] = useState(''); // Estado para la búsqueda
    const { user } = useUser();
    // Fetch perfiles desde la API
    const fetchPerfiles = async () => {
        try {
            const response = await fetch(`${server}/MgAnalisisGeneralPerfiles`);
            const data = await response.json();
            setPerfiles(data.$values);
        } catch (error) {
            console.error('Error al cargar los perfiles:', error);
        }
    };
    useEffect(() => {

        fetchPerfiles();
    }, []);

    // Fetch tipos de precios desde la API
    useEffect(() => {
        const fetchTiposPrecio = async () => {
            try {
                const response = await fetch(`${server}/MgAnalisisGeneralTiposDeAnalisisTiposDePrecios`);
                const data = await response.json();
                setTiposPrecio(data.$values);
            } catch (error) {
                console.error('Error al cargar los tipos de precios:', error);
            }
        };
        fetchTiposPrecio();
    }, []);

    // Fetch análisis disponibles desde la API
    useEffect(() => {
        const fetchAnalisisDisponibles = async () => {
            try {
                const response = await fetch(`${server}/MgAnalisisGeneralTiposDeAnalisis/`);
                const data = await response.json();
                setAnalisisDisponibles(data.$values);
            } catch (error) {
                console.error('Error al cargar los análisis disponibles:', error);
            }
        };
        fetchAnalisisDisponibles();
    }, []);

    // Fetch análisis asignados al perfil seleccionado
    useEffect(() => {
        if (perfilSeleccionado) {
            const fetchAnalisisAsignados = async () => {
                try {
                    const response = await fetch(`${server}/MgAnalisisGeneralPerfilesAnalisis/byPerfil/${perfilSeleccionado.idPerfil}`);
                    const data = await response.json();
                    setAnalisisAsignados(data.$values);
                } catch (error) {
                    console.error('Error al cargar los análisis asignados:', error);
                }
            };
            fetchAnalisisAsignados();
        }
    }, [perfilSeleccionado]);

    const obtenerFechaISOsinZ = () => {
        const fecha = new Date();
        const fechaISO = fecha.toISOString().slice(0, 19); // Solo tomar la fecha y la hora
        return fechaISO;
    };

    // Función para asignar análisis al perfil
    const asignarAnalisisAlPerfil = async (analisisId) => {
        const fechaFormateada = obtenerFechaISOsinZ();
        try {
            const analisisToSave = {
                secuencia: 0,
                IngresadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                fechaIngreso: fechaFormateada,
                idTipoPrecio: tipoPrecio,
                idTipoAnalisis: analisisId,
                idPerfil: perfilSeleccionado.idPerfil,
                modificacion: 1
            };
            console.log(analisisToSave);
            const response = await fetch(`${server}/MgAnalisisGeneralPerfilesAnalisis`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(analisisToSave),
            });
            if (response.ok) {
                setAnalisisAsignados(prev => [...prev, analisisDisponibles.find(a => a.idTipoAnalisis === analisisId)]);
            } else {
                alert('Error al asignar el análisis al perfil');
            }
        } catch (error) {
            console.error('Error al asignar el análisis al perfil:', error);
        }
    };

    // Función para quitar análisis del perfil
    const quitarAnalisisDelPerfil = async (analisisId) => {
        try {
            const response = await fetch(`${server}/MgAnalisisGeneralPerfilesAnalisis/${perfilSeleccionado.idPerfil}/${analisisId}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                setAnalisisAsignados(prev => prev.filter(a => a.idTipoAnalisis !== analisisId));

            } else {
                alert('Error al quitar el análisis del perfil');
            }
        } catch (error) {
            console.error('Error al quitar el análisis del perfil:', error);
        }
    };

    // Manejadores para la paginación
    const handleChangePageDisponibles = (event, newPage) => {
        setPageDisponibles(newPage);
    };

    const handleChangeRowsPerPageDisponibles = (event) => {
        setRowsPerPageDisponibles(parseInt(event.target.value, 10));
        setPageDisponibles(0);
    };

    const handleChangePageAsignados = (event, newPage) => {
        setPageAsignados(newPage);
    };

    const handleChangeRowsPerPageAsignados = (event) => {
        setRowsPerPageAsignados(parseInt(event.target.value, 10));
        setPageAsignados(0);
    };

    // Función para abrir el modal
    const handleOpenModal = () => {
        setOpenModal(true);
    };

    // Función para cerrar el modal
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    // Función para manejar la creación de un nuevo perfil
    const handleCreatePerfil = async () => {
        // Lógica para crear un nuevo perfil
        
        const nuevoPerfil = {
            descripcionPerfil: perfil,
            ingresadoPor: user ? user.codigoUsuario : 'ADMIN',
            fechaIngreso: new Date().toISOString(),
            modificacion: 1
        }
        console.log(nuevoPerfil);
        try {
            const response = await fetch(`${server}/MgAnalisisGeneralPerfiles`, {
                method:'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(nuevoPerfil),
            });
            if (response.ok) {
                alert('Perfil agregado correctamente');
            }else{
                alert('error al agregar el perfil');
            }

        } catch (error) {
            console.error('Error al guardar el perfil:', error);
            alert('Error al guardar el perfil');
        }
        handleCloseModal();

        fetchPerfiles();


    };



    // Filtrar análisis disponibles según la búsqueda
    const filteredAnalisisDisponibles = analisisDisponibles.filter((analisis) =>
        analisis.descripcionTipoAnalisis.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
        <div className="right_col" role="main">
            <div className="x_title">
                <h2>Gestión de Orígenes</h2>
            </div>
            <div className="x_content">
                <br />
                {/* <div className="row"> */}
                    {/* <div className="col-md-7 col-sm-6 offset-md-2"> */}
                        <Grid container spacing={3}>
                            <Grid item xs={10}>
                                <Autocomplete
                                    fullWidth
                                    options={perfiles}
                                    getOptionLabel={(option) => option.descripcionPerfil}
                                    value={perfilSeleccionado}
                                    onChange={(event, newValue) => setPerfilSeleccionado(newValue)}
                                    renderInput={(params) => <TextField {...params} label="Selecciona un Perfil" variant="outlined" />}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button variant="contained" color="primary" onClick={handleOpenModal} disabled={!tienePermiso('Crear Perfil Análisis')}>
                                    Nuevo Perfil
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Tipo de Precio</InputLabel>
                                    <Select
                                        value={tipoPrecio}
                                        onChange={(e) => setTipoPrecio(e.target.value)}
                                        label="Tipo de Precio"
                                    >
                                        {tiposPrecio.map((tipo) => (
                                            <MenuItem key={tipo.idTipoPrecio} value={tipo.idTipoPrecio}>
                                                {tipo.descripcionTipoPrecio}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <h3>Análisis Disponibles</h3>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Buscar análisis..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    style={{ marginBottom: '10px' }}
                                />
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nombre del Análisis</TableCell>
                                                <TableCell align="right">Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredAnalisisDisponibles.slice(pageDisponibles * rowsPerPageDisponibles, pageDisponibles * rowsPerPageDisponibles + rowsPerPageDisponibles).map((analisis) => (
                                                <TableRow key={analisis.idTipoAnalisis}>
                                                    <TableCell>{analisis.descripcionTipoAnalisis}</TableCell>
                                                    <TableCell align="right">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => asignarAnalisisAlPerfil(analisis.idTipoAnalisis)}
                                                            disabled={analisisAsignados.some(a => a.idTipoAnalisis === analisis.idTipoAnalisis) || !tienePermiso('Asignar Análisis a Perfil')}
                                                        >
                                                            Asignar
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredAnalisisDisponibles.length}
                                    rowsPerPage={rowsPerPageDisponibles}
                                    page={pageDisponibles}
                                    onPageChange={handleChangePageDisponibles}
                                    onRowsPerPageChange={handleChangeRowsPerPageDisponibles}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <h3>Análisis Asignados</h3>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nombre del Análisis</TableCell>
                                                <TableCell align="right">Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {analisisAsignados.slice(pageAsignados * rowsPerPageAsignados, pageAsignados * rowsPerPageAsignados + rowsPerPageAsignados).map((analisis) => (
                                                <TableRow key={analisis.idTipoAnalisis}>
                                                    <TableCell>{analisis.descripcionTipoAnalisis}</TableCell>
                                                    <TableCell align="right">
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={() => quitarAnalisisDelPerfil(analisis.idTipoAnalisis)}
                                                            disabled={!tienePermiso('Quitar Análisis de Perfil')}
                                                        >
                                                            Quitar
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={analisisAsignados.length}
                                    rowsPerPage={rowsPerPageAsignados}
                                    page={pageAsignados}
                                    onPageChange={handleChangePageAsignados}
                                    onRowsPerPageChange={handleChangeRowsPerPageAsignados}
                                />
                            </Grid>
                        </Grid>
                    {/* </div> */}
                {/* </div> */}

                {/* Modal para crear un nuevo perfil */}
                <Dialog open={openModal} onClose={handleCloseModal}>
                    <DialogTitle>Crear Nuevo Perfil</DialogTitle>
                    <DialogContent>
                        {/* Aquí puedes agregar un formulario para crear un nuevo perfil */}
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Nombre del Perfil"
                            fullWidth
                            value={perfil}
                            onChange={(e) => setPerfil(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseModal} color="secondary">Cancelar</Button>
                        <Button onClick={handleCreatePerfil} color="primary">Crear</Button>
                    </DialogActions>
                </Dialog>
            </div>
            </div>
        </>
    );
}

export default GestionAnalisisPerfil;
